<template lang="pug">
  div(v-cloak)
</template>

<script>
export default {
  data () {
    return {}
  },
  created () {
    this.$router.push({ path: this.$route.query.referrer || '/' })
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/common/pages/Dispatch/index.vue